<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.title" :errors="$page.props.errors.title" class="mb-3" label="Titel" />

        <div class="flex justify-left">
            <div class="w-1/2 ">
                <text-input v-model="form.salary_min" :errors="$page.props.errors.salary_min" class="mb-3" label="Salaris ondergrens" />
            </div>
            <div class="w-1/2 ml-3">
                <text-input v-model="form.salary_max" :errors="$page.props.errors.salary_max" class="mb-3" label="Salaris bovengrens" />
            </div>
        </div>

        <text-input v-model="form.greenness_label" :errors="$page.props.errors.greenness_label" class="mb-3" label="Greenness label" />

        <div>
            <input type="checkbox" v-model="form.ignore" id="ignore"/>
            <label for="ignore">Negeer (want ongeschikt/niet groen)</label>
        </div>

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import SelectInput from "@/admin/Shared/SelectInput";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    components: {
        TextInput,
        SelectInput,
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        jobtemplate: {
            type: Object,
            default() {
                return {};
            }
        },
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    // remember: "form",

    data() {
        return {
            form: {
                title: this.jobtemplate.title || "",
                salary_min: this.jobtemplate.salary_min || "",
                salary_max: this.jobtemplate.salary_max || "",
                greenness_label: this.jobtemplate.greenness_label || 0,
                ignore: this.jobtemplate.ignore || false,
            }
        };
    },

    methods: {
        submit() {
            var data = new FormData();

            data.append("title", this.form.title);
            data.append("salary_min", this.form.salary_min);
            data.append("salary_max", this.form.salary_max);
            data.append("greenness_label", this.form.greenness_label);
            data.append("ignore", this.form.ignore ? 1 : 0);

            this.$emit("submit", data);
        }
    }
};
</script>
